import type React from 'react'

import { faTimes } from '@fortawesome/pro-light-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { styled } from 'styled-components'

import { Breakpoints, Colors, Typography } from '@b-stock/fe-core/design-system'

export const ModalStatistic = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  padding: 1rem 3rem 0;

  &::after {
    content: '';
    display: block;
    margin-top: 0.75rem;
    border-bottom: 0.0625rem solid ${Colors.Semantic.Neutral.medium_grey};
  }
`

export const TotalSelected = styled.p`
  ${Typography.Subtitle2};
  color: ${Colors.Semantic.Neutral.black};
`

const FilterHeaderContainer = styled.div<{ $divider: boolean }>`
  padding: ${({ $divider }) => ($divider ? '1.5rem 3rem' : '1.5rem 3rem 1rem')};
  flex-shrink: 0;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  border-bottom: ${({ $divider }) =>
    $divider
      ? `0.0625rem solid ${Colors.Semantic.Neutral.medium_grey}`
      : 'none'};

  @media ${Breakpoints.max.medium} {
    padding: 1.5rem 2rem;
  }
`

const FilterHeaderLeft = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`

const FilterHeaderTitle = styled.h2`
  ${Typography.Title2}
  color: ${Colors.Semantic.Neutral.black};
  margin: 0;
  padding: 0;
  text-transform: capitalize;
`

export const FilterHeaderSelectAll = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  & label > span:last-of-type {
    font-weight: 700;
    font-size: 1.2em;
  }
`

const FilterHeaderCount = styled.span`
  ${Typography.Subtitle2}
  color: ${Colors.Semantic.Neutral.black};
`

const FilterHeaderClose = styled.button`
  appearance: none;
  border: none;
  padding: 0;
  background: inherit;
  cursor: pointer;
  font-size: 1.5rem;
  color: ${Colors.Semantic.Neutral.black};
`

type FilterModalHeaderProps = {
  title: React.ReactNode
  onClose: () => void
  children?: React.ReactNode
  countLabel?: React.ReactNode
  // Line between the header and the modal body; off when a panel follows.
  divider?: boolean
}

export const FilterModalHeader = ({
  title,
  onClose,
  children,
  countLabel,
  divider = true,
}: FilterModalHeaderProps) => {
  return (
    <FilterHeaderContainer $divider={divider}>
      <FilterHeaderLeft>
        <FilterHeaderTitle>{title}</FilterHeaderTitle>
        {(children || countLabel !== undefined) && (
          <FilterHeaderSelectAll>
            {children}
            {countLabel !== undefined && (
              <FilterHeaderCount>{countLabel}</FilterHeaderCount>
            )}
          </FilterHeaderSelectAll>
        )}
      </FilterHeaderLeft>
      <FilterHeaderClose
        type="button"
        onClick={onClose}
        data-testid="close-modal-button"
        aria-label="Close"
      >
        <FontAwesomeIcon icon={faTimes} />
      </FilterHeaderClose>
    </FilterHeaderContainer>
  )
}
